import TestingHallPage from './testing-hall'

export default {
    // prettier-ignore
    testingHall: TestingHallPage
}
